import { cn } from "@/utils/cn";
import AsyncSelect from "react-select/async";
import ReactSelect from "react-select";

const AsyncDropdown = ({
  label,
  labelClass = "",
  containerClassName = "",
  className = "",
  dropdownWrapperClassName = "",
  dropdownClassName = "",
  variant = "",
  errorText = "",
  hintText = "",
  height = 32,
  isStatic = false,
  fontSize = "16px",
  fontWeight = "300",
  zIndex = 9998,
  required = true,
  ...props
}) => {
  const customStyles = {
    container: (provided) => ({
      ...provided,
      minHeight: height,
    }),
    control: (base, state) => ({
      ...base,
      minHeight: height,
      border: state.isDisabled
        ? "0.5px solid var(--gray-v5)"
        : "0.5px solid var(--blue-dark)",
      boxShadow: "none",
      backgroundColor: "var(--white-color)",
      borderRadius: "5px",
      fontFamily: "var(--inter)",
      fontSize: fontSize,
      fontWeight: fontWeight,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
      zIndex: zIndex,
      "&:hover": {
        border: state.isDisabled
          ? "0.5px solid var(--gray-v5)"
          : "0.5px solid var(--blue-dark)",
      },
    }),
    valueContainer: (base, state) => ({
      ...base,
      minHeight: height,
    }),
    indicatorsContainer: (base, state) => ({
      ...base,
      height: height,
    }),
    placeholder: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    input: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
      height: height - 8,
    }),
    singleValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
    }),
    multiValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? "var(--gray-v5)" : "var(--blue-dark)",
      borderRadius: 4,
      height: height - 8,
    }),
    multiValueLabel: (base, state) => {
      const fontSize = Math.max(height / 2.5, 6);
      return {
        ...base,
        padding: 2,
        fontSize: fontSize,
      };
    },
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 9998,
    }),
  };

  return (
    <div>
      <div className={cn(containerClassName, "grid grid-cols-3 gap-3")}>
        <label
          htmlFor={`input${label}`}
          className={cn(
            "text-black",
            props.isDisabled ? "text-gray-400" : "",
            labelClass
          )}
        >
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
        <div
          className={cn(
            dropdownWrapperClassName,
            "ml-6 col-span-2 flex flex-col relative border-none rounded-lg transition-all"
          )}
        >
          {isStatic ? (
            <ReactSelect
              id={`input${label}`}
              styles={customStyles}
              className={`w-full ${dropdownClassName}`}
              menuPortalTarget={document.body}
              components={{
                IndicatorSeparator: () => null,
              }}
              {...props}
            />
          ) : (
            <AsyncSelect
              id={`input${label}`}
              styles={customStyles}
              className={`w-full ${dropdownClassName}`}
              menuPortalTarget={document.body}
              components={{
                IndicatorSeparator: () => null,
              }}
              {...props}
            />
          )}
          {hintText && (
            <div className="mt-2 mb-0.5 text-gray-600">{hintText}</div>
          )}
          {errorText && (
            <div className="mt-2 mb-0.5 text-[red]">{errorText}*</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AsyncDropdown;
